import { c as _c } from "react/compiler-runtime";
export default function TheLineIcon() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <img src="/OnCyber-Icon.jpg" alt="OnCyber" className="tw-flex-shrink-0 tw-rounded-full tw-ring-1 tw-ring-white/20 tw-h-5 tw-w-5 tw-object-contain tw-object-center tw-align-top" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}